import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  AgreementAreaParts,
  AirportComponent,
  CheckboxComponent,
  DateSelectorParts,
  LModalContentsWidthType,
  ModalType,
} from '@lib/components';
import { AmcLoginComponent } from '@lib/components/shared-ui-components/amc-login/amc-login.component';
import { AmcLoginHeaderComponent } from '@lib/components/shared-ui-components/amc-login/amc-login-header.component';
import {
  AirportListParts,
  ComponentAirport,
  TerminalType,
} from '@lib/components/shared-ui-components/airport/airport.state';
import { SupportClass, SupportPageComponent } from '@lib/components/support-class';
import { Airport } from '@lib/interfaces/airport';
import { CommonLibService, ModalService, PageInitService } from '@lib/services';
import { SubTestComponent } from './sub-test/sub-test.component';
import { IdSubTestComponent } from './id-sub-test/id-sub-test.component';
import { IdSubTestHeaderComponent } from './id-sub-test/id-sub-test-header.component';
import { IdSubTestFooterComponent } from './id-sub-test/id-sub-test-footer.component';
import {
  AlertType,
  AnaBizLoginStatusType,
  ApiErrorResponseModel,
  AswContextType,
  GenderCodeType,
  IFlyAddressType,
  IFlyGenderType,
  IFlyPhoneNumberType,
  LoginStatusType,
  MemberKindCodeType,
  PremiumStatusCodeType,
  Region,
  TierLevelType,
  ValidateOptions,
  ValidationErrorInfo,
  AnaBizContextType,
  AnaBizContextModel,
} from '@lib/interfaces';
import { SubTestPayload } from './sub-test/sub-test.state';
import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { AMCMemberState, AnaBizContextState } from '@lib/store';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ssnTestAirports, ssnTestRegions, TestSsnDynamicParams } from './test-ssn.state';
import { RoutesResRoutes } from '@conf/routes.config';
import { AnabizAuthorizationService } from '@common/services/anabiz-authorization/anabiz-authorization.service';
import { StaticMsgPipe } from '@lib/pipes';
import { FormBound } from './test-ssn.state';
import { AswValidators } from '@lib/helpers';

@Component({
  selector: 'asw-test-ssn',
  templateUrl: './test-ssn.component.html',
  styleUrls: ['./test-ssn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestSsnComponent extends SupportPageComponent implements OnInit, AfterViewInit {
  pageId = 'Ssn';
  functionId = 'Test';

  public boxtext = ['abc', 'defg', '<u><i>123</i></u>'];
  public boxSelect = '';
  public boxSelectValue = 0;

  //動的文言パラメータ用のSubject　初期値がないとPageInitが終わらないのでBehaviorSubjectにすること
  public dynamicSubject = new BehaviorSubject<TestSsnDynamicParams>({ testNumber: 0, testString: '' });

  constructor(
    private _common: CommonLibService,
    private _changeDetector: ChangeDetectorRef,
    private _modal: ModalService,
    private _translateService: TranslateService,
    private _router: Router,
    private _pageInitService: PageInitService,
    private _anaBizAuthorizationService: AnabizAuthorizationService,
    private _staticMsgPipe: StaticMsgPipe
  ) {
    super(_common, _pageInitService);
    this.defaultBound = this.createInitialFormBound(0, null, null);

    //デバッグに不便なので追加
    /*
    if (_translateService.getDefaultLang() !== this._common.aswContextStoreService.aswContextData.lang) {
      this._common.aswContextStoreService.updateAswContext({
        pointOfSaleId: 'NYONH08AA',
        lang: _translateService.getDefaultLang(),
      });
    }
    */
    //初期選択
    this.boxSelect = '123';
  }
  ngAfterViewInit(): void {
    // set~を使用して初期値を入れる場合
    // this.airportToComponent.setAirport(
    //   this.airportToComponent.airportList.find((air) => air.airport_code === 'NYC') || null
    // )

    // 空港選択フォーム
    // this.airportFormGroup.controls.airportDep.addValidators(this.validatorWrong());
    // this.airportFormGroup.controls.airportArr.addValidators(this.validatorWrong());
    this.airportFormGroup.markAllAsTouched();
    this.dateSelectorFormGroup.markAllAsTouched();
    this._changeDetector.detectChanges();
  }

  reload(): void {}
  init(): void {
    //動的文言パラメータの設定、paramsにセットしておくとベースクラス内でPageInitに渡してくれる
    this.params = this.dynamicSubject.asObservable();
    //this.common.aswContextStoreService.updateAswContext({ lang: 'ja' });

    // 空港選択フォーム
    this.airportFormControl = new FormControl(this.selectedAirport);
    this.airportFormGroup = new FormGroup({
      airportDep: new FormControl(this.selectedAirportFrom, [
        this.validatorRequired(),
        this.validatorSame('airportArr'),
      ]),
      airportArr: new FormControl(this.selectedAirportTo, [this.validatorSame('airportDep')]),
      airportTra: new FormControl(this.selectedAirportTransit, [this.validatorSame('airportDep')]),
    });

    // 出発日選択フォーム
    this.dateSelectorFormControl = new FormControl(this.selectedDateOneway);
    this.dateSelectorFormGroup = new FormGroup({
      formDep: new FormControl(this.selectedDate, [this.validatorPreviousDate()]),
      formArr: new FormControl(this.selectedReturnDate, [this.validatorPreviousDate()]),
    });

    // パターン4 boundListの初期設定処理
    this.boundList = [this.defaultBound, this.defaultBound];
  }
  destroy(): void {}

  public toggleCheck = true;
  public testDate: Date | null = new Date(2023, 6, 3);
  public initialDate: Date = new Date(2023, 5, 3);
  public selectModalType = new FormControl();
  public selectModalWidth = new FormControl();

  public changeDate(date: Date) {
    console.log(date);
  }

  public toggleChange(event: any) {
    console.log(this.toggleCheck, event);
  }

  errorOn() {
    this._common.errorsHandlerService.setRetryableError('page', {
      errorMsgId: 'E0001',
      params: {
        key: '0',
        value: 'test',
        dontTranslate: true,
      },
    });
  }
  errorOff() {
    this._common.errorsHandlerService.clearRetryableError();
  }
  warningOn() {
    this._common.alertMessageStoreService.setAlertWarningMessage({
      contentHtml: 'E0002',
      isCloseEnable: true,
      alertType: AlertType.WARNING,
      errorMessageId: 'E0002',
      apiErrorCode: 'API00001',
      interpolateParams: { ['0']: 'testWarning' },
    });
  }
  infomationOn() {
    this._common.alertMessageStoreService.setAlertInfomationMessage({
      contentHtml: 'heading.agreementGuidance',
      isCloseEnable: false,
      alertType: AlertType.INFOMATION,
    });
  }
  alertClear() {
    this._common.alertMessageStoreService.resetAlertMessage();
  }

  warningIdOn(messageId: string) {
    this._common.alertMessageStoreService.setAlertWarningMessage({
      contentHtml: messageId,
      isCloseEnable: false,
      alertType: AlertType.WARNING,
      contentId: messageId,
      apiErrorCode: '',
      interpolateParams: { ['0']: 'testWarning' },
    });
  }
  warningIdDelete(messageId: string) {
    this._common.alertMessageStoreService.removeAlertWarningMessage(messageId);
  }

  infomationIdOn(messageId: string) {
    this._common.alertMessageStoreService.setAlertInfomationMessage({
      contentHtml: messageId,
      isCloseEnable: false,
      alertType: AlertType.INFOMATION,
      contentId: messageId,
    });
  }
  infomationIdDelete(messageId: string) {
    this._common.alertMessageStoreService.removeAlertInfomationMessage(messageId);
  }

  tabClick(event: number) {
    console.log(event);
  }

  public dateFromYmd = new Date(2023, 0, 1);
  public dateToYmd = new Date(2030, 11, 31);

  agreeStatus: boolean = false;
  agreementAreaParts: AgreementAreaParts = {
    partsTitle: 'Terms of Condition',
    submitText: 'Submit',
    cancelText: 'Cancel',
    isModal: false,
  };

  agreeStatus2: boolean = false;
  agreementAreaParts2: AgreementAreaParts = {
    cancelText: 'Cancel',
    isModal: false,
  };

  ///////////////////////////////////////////////
  ///////////   空港選択  ///////////////////////

  @ViewChild('airportTo') airportToComponent!: AirportComponent;

  /** 空港リスト(test-ssn内で作成) */
  public airportListParts: AirportListParts = {
    inputLabel: 'Airport',
    airportList: ssnTestAirports,
    regionList: ssnTestRegions,
  };

  /** 出発地(パターン１) */
  public selectedAirport: Airport | null = null;

  /** フォーム(パターン１) */
  public airportFormControl = new FormControl();

  /** 空港リスト(出発地パターン２) */
  public airportListPartsFrom: AirportListParts = {
    terminalType: TerminalType.DEPARTURE,
    inputLabel: this._staticMsgPipe.transform('label.departureLocation'),
  };
  /** 空港リスト(到着地パターン２) */
  public airportListPartsTo: AirportListParts = {
    terminalType: TerminalType.DESTINATION,
    inputLabel: this._staticMsgPipe.transform('label.arrivalLocation'),
  };

  /** 空港リスト(出発地パターン5) */
  public airportListPartsFromExcludeInputLabel: AirportListParts = {
    terminalType: TerminalType.DEPARTURE,
  };
  /** 空港リスト(到着地パターン5) */
  public airportListPartsToExcludeInputLabel: AirportListParts = {
    terminalType: TerminalType.DESTINATION,
  };

  /** 空港リスト(乗継地パターン３) */
  public airportListPartsTransit: AirportListParts = {
    terminalType: TerminalType.NONE,
    inputLabel: this._staticMsgPipe.transform('label.transferconditionAir'),
  };

  /** 出発地(パターン２) */
  public selectedAirportFrom: Airport | null = {
    name: '',
    english_name: '',
    airport_code: 'TYO',
    search_for_airport_code: '',
    region_code: '',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 0,
    index: '',
    display_type: '0',
  };
  /** 到着地(パターン２) */
  public selectedAirportTo: Airport | null = null;

  /** 乗継地(パターン３) */
  public selectedAirportTransit: Airport | null = null;

  /** 描画用入力項目 */
  public boundList!: Array<FormBound>;

  readonly MAX_BOUND_LIST_LENGTH = 6;

  private defaultBound: FormBound;

  /** フォームグループ(パターン２) */
  public airportFormGroup = new FormGroup({
    /** 出発地 */
    airportDep: new FormControl(),
    /** 到着地 */
    airportArr: new FormControl(),
    /** 乗継地 */
    airportTra: new FormControl(),
  });
  /** フォームコントロール化 */
  public get f() {
    return this.airportFormGroup?.controls as { [key: string]: FormControl };
  }

  /** 旧国内ASW取扱検索条件フラグ */
  public isOldAswTerm = false;
  public toggleOldAswTerm() {
    this.isOldAswTerm = !this.isOldAswTerm;
  }

  /** 空港リスト(同一空港バリデーションに使用) */
  private receivedDataInParent?: ComponentAirport[];
  /** airport.componentから空港一覧を取得 */
  public receiveDataFromChild(data: ComponentAirport[]) {
    this.receivedDataInParent = { ...data };
  }
  /** 空港選択イベント */
  public changeAirportEvent(value?: Airport) {
    console.log(value);
  }

  /** 空港選択バリデーション(必須) */
  private validatorRequired(option?: ValidateOptions): ValidatorFn {
    return (control: AbstractControl): { [key: string]: ValidationErrorInfo } | null => {
      const value = control.value;
      if (!value) {
        return {
          'validate-Required': {
            errorMsgId: option?.errorMsgId || '空港を選択してください',
            params: option?.params,
          },
        };
      }
      return null;
    };
  }
  /** 空港選択バリデーション(指定された空港が存在しない) */
  private validatorWrong(option?: ValidateOptions): ValidatorFn {
    return (control: AbstractControl): { [key: string]: ValidationErrorInfo } | null => {
      const value = control.value;
      let result: { [key: string]: ValidationErrorInfo } | null;
      if (value) {
        const ok = Object.values(this.receivedDataInParent as Object).some((airport) => {
          return airport.airport_code === value || airport.displayName === value;
        });
        if (ok) {
          result = null;
        } else {
          result = {
            'validate-wrong': {
              errorMsgId: option?.errorMsgId || '入力間違いです',
              params: option?.params,
            },
          };
        }
        return result;
      }
      return null;
    };
  }
  /** 空港選択バリデーション(同一空港) */
  private validatorSame(controlName: string, option?: ValidateOptions): ValidatorFn {
    return (control: AbstractControl): { [key: string]: ValidationErrorInfo } | null => {
      const value = control.value;
      const other = this.airportFormGroup.get(controlName)?.value;
      if (value && other && value === other) {
        return {
          'validate-same': {
            errorMsgId: option?.errorMsgId || '同一空港です',
            params: option?.params,
          },
        };
      }
      return null;
    };
  }

  /////////////////////////////////////////////////
  ///////////   出発日選択  ///////////////////////

  //// 片道 ////

  /** カレンダーの期間(片道パターン1) */
  public dateSelectorPartsOneway: DateSelectorParts = {
    baseDate: new Date(2024, 0, 1),
    lastDate: new Date(2026, 0, 1),
    isRoundTrip: false,
  };
  /** 往路日(片道パターン１) */
  public selectedDateOneway: Date | null = null;
  /** フォーム(片道パターン１) */
  public dateSelectorFormControl = new FormControl();

  //// 往復 ////

  /** カレンダーの期間(往復パターン２) */
  public dateSelectorParts: DateSelectorParts = {
    baseDate: new Date(2024, 0, 1),
    lastDate: new Date(2026, 0, 1),
    isRoundTrip: true,
  };
  /** 往路日(往復パターン２) */
  //public selectedDate: Date | null = new Date(2024, 2, 20);
  public selectedDate: Date | null = null;
  /** 復路日(往復パターン２) */
  //public selectedReturnDate: Date | null = new Date(2024, 2, 25);
  public selectedReturnDate: Date | null = null;
  /** フォームグループ(往復パターン２) */
  public dateSelectorFormGroup = new FormGroup({
    /** 往路日 */
    formDep: new FormControl(),
    /** 復路日 */
    formArr: new FormControl(),
  });

  /** カレンダーの期間(片道パターン3) */
  /** baseDateのと指定なしのパターン */
  public dateSelectorPartsOnewayWithoutBaseDate: DateSelectorParts = {
    baseDate: undefined,
    lastDate: new Date(2026, 0, 1),
    isRoundTrip: false,
  };
  /** 往路日(片道パターン3) */
  public selectedDateOnewayWithoutBaseDate: Date | null = null;
  /** フォーム(片道パターン3) */
  public dateSelectorFormControlWithoutBaseDate = new FormControl();

  /** 出発日選択バリデーション(過去日)*/
  private validatorPreviousDate(option?: ValidateOptions): ValidatorFn {
    return (control: AbstractControl): { [key: string]: ValidationErrorInfo } | null => {
      const value: Date = control.value;
      if (value && value < new Date()) {
        return {
          validate: {
            errorMsgId: option?.errorMsgId || '過去日です',
            params: option?.params,
          },
        };
      }
      return null;
    };
  }

  /////////////////////////////////////////////////
  ///////////   年月日プルダウン  //////////////////
  initDate = new Date(2026, 11, 11);
  /**
   * 2025年11月11日の場合にエラーとするValidator
   */
  private _validateNov11_2025(option?: ValidateOptions): ValidatorFn {
    const validationError = {
      'validate-nov112025': {
        errorMsgId: option?.errorMsgId || 'E0849',
        params: option?.params,
      },
    };
    return (control: AbstractControl): { [key: string]: ValidationErrorInfo } | null => {
      const value = control.value;
      if (value instanceof Date) {
        const isNov11_2025 = value.getFullYear() === 2025 && value.getMonth() === 10 && value.getDate() === 11;
        return isNov11_2025 ? validationError : null;
      } else {
        return null;
      }
    };
  }
  public ymdForm = new FormGroup({
    ymd: new FormControl(this.initDate, [AswValidators.required(), this._validateNov11_2025()]),
  });

  /**
   * 選択中の日付を10日進める
   * ※setValue検証用
   */
  public add10days() {
    const currentDate = this.ymdForm.get('ymd')?.value;
    if (currentDate instanceof Date) {
      const newDate = new Date(currentDate);
      newDate.setDate(newDate.getDate() + 10);
      this.ymdForm.get('ymd')?.setValue(newDate);
    }
  }

  /**
   * 年月日プルダウンsubmit時処理
   */
  public ymdSubmit(): void {
    this.ymdForm.controls['ymd'].markAsTouched();
    const data = this.ymdForm.controls.ymd.value;
    console.log(data);
    console.log(this.ymdForm.invalid);
    console.log(this.ymdForm.touched);
    this._changeDetector.markForCheck();
  }

  /**
   * 動的文言にパラメータを渡す
   * @param num テスト値
   * @param str テスト値
   */
  dynamicTest(num: number, str: string) {
    //nextをコールし、PageInitService内のSubscribeを動かすことで再びjsファイルが更新後のパラメータで動き出す
    //再取得した動的文言が動的文言ストアに格納される
    this.dynamicSubject.next({ testNumber: num, testString: str });
    /////////////////////////////////////////////////
  }
  dynamicOn() {
    this._common.aswCommonStoreService.updateAswCommon({
      functionId: 'Test',
      pageId: 'Ssn2',
    });
    this._pageInitService.startInit();
    this._pageInitService.endInit(this.params);
  }
  dynamicOff() {
    this._common.aswCommonStoreService.updateAswCommon({
      functionId: 'Test',
      pageId: 'Ssn',
    });
    this._pageInitService.startInit();
    this._pageInitService.endInit(this.params);
  }

  modalCloseEnable = false;

  modalCloseChecked(checkbox: CheckboxComponent) {
    this.modalCloseEnable = checkbox.checked;
  }

  public error1: ValidationErrorInfo = {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'testError',
      dontTranslate: true,
    },
  };

  public error2: ValidationErrorInfo = {
    errorMsgId: 'E0001',
    params: {
      key: 0,
      value: 'testError',
      dontTranslate: true,
    },
  };

  public error3: ValidationErrorInfo | string = '';

  async testModal() {
    const part = this._modal.defaultBlockPart(SubTestComponent, 'testModal');
    part.closeBackEnable = this.modalCloseEnable;
    part.closeEvent = () => {
      console.log('モーダルが閉じました');
    };
    part.payload = {
      testFunc: () => {
        console.log('組み込み元から渡されたペイロード');
      },
      test: '組み込み元から渡された文字列',
    } as SubTestPayload | null;

    switch (this.selectModalType.value) {
      case 'option1':
        part.type = ModalType.TYPE1;
        break;
      case 'option2':
        part.type = ModalType.TYPE2;
        break;
      case 'option3':
        part.type = ModalType.TYPE3;
        break;
      case 'option4':
        part.type = ModalType.TYPE4;
        break;
      case 'option5':
        part.type = ModalType.TYPE5;
        break;
      case 'option6':
        part.type = ModalType.TYPE6;
        break;
      case 'option7':
        part.type = ModalType.TYPE7;
        break;
      case 'option8':
        part.type = ModalType.TYPE8;
        break;
      case 'option9':
        part.type = ModalType.TYPE9;
        break;
      case 'option10':
        part.type = ModalType.TYPE10;
        break;
    }

    switch (this.selectModalWidth.value) {
      case 'option1':
        part.modalWidth = LModalContentsWidthType.MODAL_TAB_W345;
        break;
      case 'option2':
        part.modalWidth = LModalContentsWidthType.MODAL_TAB_W384;
        break;
      case 'option3':
        part.modalWidth = LModalContentsWidthType.MODAL_TAB_W540;
        break;
      case 'option4':
        part.modalWidth = LModalContentsWidthType.MODAL_TAB_W768;
        break;
      case 'option5':
        part.modalWidth = LModalContentsWidthType.MODAL_PC_W500;
        break;
      case 'option6':
        part.modalWidth = LModalContentsWidthType.MODAL_PC_W600;
        break;
      case 'option7':
        part.modalWidth = LModalContentsWidthType.MODAL_PC_W768;
        break;
      case 'option8':
        part.modalWidth = LModalContentsWidthType.MODAL_PC_W1000;
        break;
      case 'option9':
        part.modalWidth = LModalContentsWidthType.NONE;
        break;
    }
    this._modal.showSubModal(part);
  }

  async testIdModal() {
    const part = this._modal.defaultIdPart(
      IdSubTestComponent,
      IdSubTestHeaderComponent,
      IdSubTestFooterComponent,
      'testIdModal'
    );
    part.closeBackEnable = this.modalCloseEnable;
    part.closeEvent = () => {
      console.log('モーダルが閉じました');
    };
    part.payload = {
      testFunc: () => {
        console.log('組み込み元から渡されたペイロード');
      },
      test: '組み込み元から渡された文字列',
    } as SubTestPayload | null;

    switch (this.selectModalType.value) {
      case 'option1':
        part.type = ModalType.TYPE1;
        break;
      case 'option2':
        part.type = ModalType.TYPE2;
        break;
      case 'option3':
        part.type = ModalType.TYPE3;
        break;
      case 'option4':
        part.type = ModalType.TYPE4;
        break;
      case 'option5':
        part.type = ModalType.TYPE5;
        break;
      case 'option6':
        part.type = ModalType.TYPE6;
        break;
      case 'option7':
        part.type = ModalType.TYPE7;
        break;
      case 'option8':
        part.type = ModalType.TYPE8;
        break;
      case 'option9':
        part.type = ModalType.TYPE9;
        break;
      case 'option10':
        part.type = ModalType.TYPE10;
        break;
    }

    switch (this.selectModalWidth.value) {
      case 'option1':
        part.modalWidth = LModalContentsWidthType.MODAL_TAB_W345;
        break;
      case 'option2':
        part.modalWidth = LModalContentsWidthType.MODAL_TAB_W384;
        break;
      case 'option3':
        part.modalWidth = LModalContentsWidthType.MODAL_TAB_W540;
        break;
      case 'option4':
        part.modalWidth = LModalContentsWidthType.MODAL_TAB_W768;
        break;
      case 'option5':
        part.modalWidth = LModalContentsWidthType.MODAL_PC_W500;
        break;
      case 'option6':
        part.modalWidth = LModalContentsWidthType.MODAL_PC_W600;
        break;
      case 'option7':
        part.modalWidth = LModalContentsWidthType.MODAL_PC_W768;
        break;
      case 'option8':
        part.modalWidth = LModalContentsWidthType.MODAL_PC_W1000;
        break;
      case 'option9':
        part.modalWidth = LModalContentsWidthType.NONE;
        break;
    }
    this._modal.showSubPageModal(part);
  }

  /**
   * APIサンプル
   */
  async testApi() {}

  private apiError(error: ApiErrorResponseModel) {
    let messageId = '';
    switch (error['errors']![0].code) {
      case 'EAPZ0000XX':
        messageId = 'E0XXX';
        break; //エラー１
      case 'EAPZ0000YY':
        messageId = 'E0YYY';
        break; //エラー２
      default:
        messageId = 'E0ZZZ';
        break;
    }
    this._common.errorsHandlerService.setRetryableError('page', {
      errorMsgId: messageId,
      apiErrorCode: error['errors']![0].code,
    });
  }

  loginModal() {
    const diarogPart = this._modal.defaultIdPart(AmcLoginComponent, AmcLoginHeaderComponent);
    diarogPart.payload = {
      submitEvent: () => this.submitHandleLogin(),
    };
    this._modal.showSubPageModal(diarogPart);
  }

  submitHandleLogin() {
    alert('submit login api');
  }

  login() {
    this._common.aswContextStoreService.updateAswContext({
      [AswContextType.LOGIN_STATUS]: LoginStatusType.REAL_LOGIN,
    });

    const data: Required<AMCMemberState> = {
      memberKindCode: MemberKindCodeType.MEMBER_AID,
      gender: GenderCodeType.MALE,
      premiumStatus: PremiumStatusCodeType.PLATINUM,
      tierLevel: TierLevelType.PLT,
      amcNumber: '12345678',
      cardStatusCode: 'abc',
      letterName: '空野　太郎',
      alteaName: {
        lastName: 'taro',
        firstName: 'sorano',
      },
      mileBalance: 10,
      afaPrimeMemberIdentification: '',
      upgradePointBalanceThisYear: 1000,
      upgradePointBalanceNextYear: 3000,
      mileBalanceAfa: 15000,
      premiumPointTotal: 30000,
      premiumPointAnaTotal: 17555,
      skyCoinBalance: 1234,
      bookDate: '20231201',
      anaCardTypeCode: '',
      iFlyMemberInfo: {
        profileDetails: {
          customerNumber: '1234567890',
          status: 'A',
          individualInfo: {
            preferredEmailAddress: IFlyAddressType.HOME,
            preferredPhoneNumber: IFlyPhoneNumberType.HOME_MOBILE,
            givenName: 'TARO',
            familyName: 'SORANO',
            secondName: '太郎',
            secondLastName: '空野',
            gender: IFlyGenderType.MALE,
            dateOfBirth: '29-May-1985',
            memberContactInfos: [
              {
                addressType: IFlyAddressType.HOME,
                emailAddress: 'sorano@mail.co.jp',
                phoneISDCode: '+81',
                phoneNumber: '312345678',
                mobileISDCode: '+81',
                mobileNumber: '9012345678',
              },
            ],
          },
          customerDynamicAttribute: [
            {
              attributeCode: '50',
              attributeValue: 'R',
            },
          ],
        },
        programDetails: [
          {
            accountStatus: 'A',
            tierCode: '',
            programDynamicAttribute: [
              {
                attributeCode: '1',
                attributeValue: '1',
              },
            ],
            pointDetails: [
              {
                pointType: '',
                points: 12345,
              },
            ],
          },
        ],
        document: [
          {
            documentType: 'P',
            issuedDate: '30-Jun-2024',
            expiryDate: '01-Jan-2025',
          },
        ],
      },
    };
    this._common.amcMemberStoreService.updateAMCMember(data);
  }
  tempLogin() {
    this._common.aswContextStoreService.updateAswContext({
      [AswContextType.LOGIN_STATUS]: LoginStatusType.TEMPORARY_LOGIN,
    });

    const data: Required<AMCMemberState> = {
      memberKindCode: MemberKindCodeType.MEMBER_AID,
      gender: GenderCodeType.MALE,
      premiumStatus: PremiumStatusCodeType.PLATINUM,
      tierLevel: TierLevelType.PLT,
      amcNumber: '12345678',
      cardStatusCode: 'def',
      letterName: '仮野　太郎',
      alteaName: {
        lastName: 'taro',
        firstName: 'karino',
      },
      mileBalance: 10,
      afaPrimeMemberIdentification: '',
      upgradePointBalanceThisYear: 1000,
      upgradePointBalanceNextYear: 3000,
      mileBalanceAfa: 15000,
      premiumPointTotal: 30000,
      premiumPointAnaTotal: 17555,
      skyCoinBalance: 1234,
      bookDate: '20231201',
      anaCardTypeCode: '',
      iFlyMemberInfo: {
        profileDetails: {
          customerNumber: '1234567890',
          status: 'A',
          individualInfo: {
            preferredEmailAddress: IFlyAddressType.HOME,
            preferredPhoneNumber: IFlyPhoneNumberType.HOME_MOBILE,
            givenName: 'TARO',
            familyName: 'SORANO',
            secondName: '太郎',
            secondLastName: '空野',
            gender: IFlyGenderType.MALE,
            dateOfBirth: '29-May-1985',
            memberContactInfos: [
              {
                addressType: IFlyAddressType.HOME,
                emailAddress: 'sorano@mail.co.jp',
                phoneISDCode: '+81',
                phoneNumber: '312345678',
                mobileISDCode: '+81',
                mobileNumber: '9012345678',
              },
            ],
          },
          customerDynamicAttribute: [
            {
              attributeCode: '50',
              attributeValue: 'R',
            },
          ],
        },
        programDetails: [
          {
            accountStatus: 'A',
            tierCode: '',
            programDynamicAttribute: [
              {
                attributeCode: '1',
                attributeValue: '1',
              },
            ],
            pointDetails: [
              {
                pointType: '',
                points: 12345,
              },
            ],
          },
        ],
        document: [
          {
            documentType: 'P',
            issuedDate: '30-Jun-2024',
            expiryDate: '01-Jan-2025',
          },
        ],
      },
    };
    this._common.amcMemberStoreService.updateAMCMember(data);
  }
  logout() {
    this._common.aswContextStoreService.updateAswContext({
      [AswContextType.LOGIN_STATUS]: LoginStatusType.NOT_LOGIN,
    });
    this._common.amcMemberStoreService.setAMCMember({
      memberKindCode: '',
      gender: '',
      premiumStatus: '',
      tierLevel: '',
      amcNumber: '',
      cardStatusCode: '',
      letterName: '',
      afaPrimeMemberIdentification: '',
      bookDate: '',
      iFlyMemberInfo: undefined,
      anaCardTypeCode: '',
    });
  }
  enableLogin() {
    this._common.aswCommonStoreService.updateAswCommon({
      isEnabledLogin: true,
    });
  }
  disableLogin() {
    this._common.aswCommonStoreService.updateAswCommon({
      isEnabledLogin: false,
    });
  }
  bizLogin() {
    this._common.aswContextStoreService.updateAswContext({
      [AswContextType.ANA_BIZ_LOGIN_STATUS]: AnaBizLoginStatusType.LOGIN,
    });

    const data: Required<AnaBizContextModel> = {
      authInfo: {},
      seamlessParameter: {},
      allBizContext: {
        companyId: 'S123456789',
        loginUserID: '0000000001',
        companyName: 'ANAシステムズ株式会社',
        creditId: 123456789123,
        isIssuable: 1,
        commercialFareFamilyList: '01,02,03',
        issueType: 0,
        familyName: 'SORANO',
        givenName: 'TARO',
        emailAddress: 'sorano@mail.co.jp',
        dateOfBirth: '29-May-1985',
        gender: 'M',
        passengerMembershipNumber: 1234567890,
        addressType: 'HP',
        phoneISDCode: '+81',
        phoneNumber: 9012345678,
        customerId: 123456,
        departmentId: 123456,
        departmentName: '営業部',
        userSeq: '0000000001',
        agentSeq: '0000000001',
        bizGeneralItem1: '2401010112345',
        bizGeneralItem2: '1234567890',
        bizGeneralItem3: '4/1 XXの打合せのため※羽田T2',
      },
    };
    this._common.anaBizContextStoreService.setAnaBizContext(data);
  }
  bizLogout() {
    this._common.aswContextStoreService.updateAswContext({
      [AswContextType.ANA_BIZ_LOGIN_STATUS]: AnaBizLoginStatusType.NOT_LOGIN,
    });
    this._common.anaBizContextStoreService.resetAnaBizContext();
  }

  /** １つの区間の入力項目値を生成する */
  private createInitialFormBound(
    index: number,
    valueSelectedMin: number | null,
    valueSelectedMax: number | null
  ): FormBound {
    const departureTimeWindow = new FormControl<number[] | null>(
      valueSelectedMin != null && valueSelectedMax != null ? [valueSelectedMin, valueSelectedMax] : null
    );

    const formBound = {
      originLocation: null,
      destinationLocation: null,
      departureDate: null,
      originLocationFormControl: new FormControl(),
      destinationLocationFormControl: new FormControl(),
      departureDateFormControl: new FormControl(),
      departureTimeWindow: departureTimeWindow,
      subscriptionDepartureTimeWindow: null,
    };
    return formBound;
  }
  flightSearch() {
    this._router.navigateByUrl(RoutesResRoutes.FLIGHT_SEARCH);
  }
  apfLogin() {
    this._common.aswContextStoreService.updateAswContext({
      [AswContextType.POINT_OF_SALE_ID]: 'TYONH08AP',
      [AswContextType.APF_CODE]: 'ASW1',
    });
  }
  apfLogout() {
    this._common.aswContextStoreService.updateAswContext({
      [AswContextType.POINT_OF_SALE_ID]: 'TYONH08AA',
      [AswContextType.APF_CODE]: '',
    });
  }
  organizationSelectRequired() {
    this._common.aswContextStoreService.updateAswContext({
      [AswContextType.ANA_BIZ_LOGIN_STATUS]: AnaBizLoginStatusType.ORGANIZATION_SELECT_REQUIRED,
    });

    const data: Required<AnaBizContextModel> = {
      authInfo: {
        companyCode: 'FCL12345',
        companyAccountCode: 'SCL12345',
        contractType: '01',
        companyInfoA: {
          cancellationDate: '2025-12-28',
          companyName: 'テスト企業1',
          companyNameEn: 'TEST COMPANY1',
          issueFlag: '1',
          pauseFlag: '0',
          onePaxFlag: '0',
          eCffList: ['infoAeCff1', 'infoAeCff2', 'infoAeCff3', 'infoAeCff4'],
          fCffList: ['infoAfCff1', 'infoAfCff2', 'infoAfCff3', 'infoAfCff4'],
        },
        companyInfoC: {
          cancellationDate: '2033-01-01',
          contractSecName: 'テスト契約部署1',
          contractSecNameEn: 'TEST CONTRACT SEC1',
          issueFlag: '0',
          pauseFlag: '1',
          onePaxFlag: '1',
          eCffList: [],
          fCffList: [],
        },
        companyManagementCodeInfo: {
          texts: [
            {
              no: '1',
              activateFlag: '1',
              code: 'ABC',
            },
            {
              no: '2',
              activateFlag: '0',
              code: 'DEF',
            },
          ],
          comboNames: ['TEST1', 'TEST2', 'TEST3', 'TEST4'],
        },
        roles: ['TRAVELER', 'APPROVER', 'DEPARTMENT_ADMINISTRATOR', 'COMPANY_ADMINISTRATOR'],
      },
      seamlessParameter: {
        amcMemberNumber: '9904700095',
        companyManagementCode1: '',
        companyManagementCode2: '',
        companyManagementCode3: '',
        companyManagementCode4: '',
        departureDate1: '2024-08-28',
        departureDate2: '2024-09-11',
        sendDataFlag: '0',
        sendDataUrl: '',
        sendDataType: '1',
      },
      allBizContext: {
        companyId: 'IBX1234,20240101235959',
        loginUserID: '0000000001,20240101235959',
        companyName: 'ANAシステムズ株式会社',
        creditId: 11,
        isIssuable: 1,
        commercialFareFamilyList: '',
        issueType: 0,
        familyName: 'SORANO',
        givenName: 'TARO',
        emailAddress: 'sorano@mail.co.jp',
        dateOfBirth: '29-May-1985',
        gender: 'M',
        passengerMembershipNumber: 1234567890,
        addressType: IFlyAddressType.BUSINESS,
        phoneISDCode: '+81',
        phoneNumber: 9012345678,
        customerId: 123456,
        departmentId: 123456,
        departmentName: '営業部',
        userSeq: '1',
        agentSeq: '1',
        bizGeneralItem1: '2401010112345',
        bizGeneralItem2: '1234567890',
        bizGeneralItem3: '4/1 XXの打合せのため※羽田T2',
      },
    };
    this._common.anaBizContextStoreService.updateAnaBizContext(data);
  }

  public pauseFlag = this._common.anaBizContextStoreService.anaBizContextData.authInfo?.companyInfoC?.pauseFlag;

  changepauseFlag() {
    console.log('before:' + this._common.anaBizContextStoreService.anaBizContextData.authInfo?.companyInfoC?.pauseFlag);
    this.pauseFlag =
      this._common.anaBizContextStoreService.anaBizContextData.authInfo?.companyInfoC?.pauseFlag === '0' ? '1' : '0';
    const data: Required<AnaBizContextModel> = {
      authInfo: {
        companyCode: 'FCL12345',
        companyAccountCode: 'SCL12345',
        contractType: '01',
        companyInfoA: {
          cancellationDate: '2025-12-28',
          companyName: 'テスト企業1',
          companyNameEn: 'TEST COMPANY1',
          issueFlag: '1',
          pauseFlag: '0',
          onePaxFlag: '0',
          eCffList: ['infoAeCff1', 'infoAeCff2', 'infoAeCff3', 'infoAeCff4'],
          fCffList: ['infoAfCff1', 'infoAfCff2', 'infoAfCff3', 'infoAfCff4'],
        },
        companyInfoC: {
          cancellationDate: '2033-01-01',
          contractSecName: 'テスト契約部署1',
          contractSecNameEn: 'TEST CONTRACT SEC1',
          issueFlag: '0',
          pauseFlag: this.pauseFlag,
          onePaxFlag: '1',
          eCffList: [],
          fCffList: [],
        },
        companyManagementCodeInfo: {
          texts: [
            {
              no: '1',
              activateFlag: '1',
              code: 'ABC',
            },
            {
              no: '2',
              activateFlag: '0',
              code: 'DEF',
            },
          ],
          comboNames: ['TEST1', 'TEST2', 'TEST3', 'TEST4'],
        },
        roles: ['TRAVELER', 'APPROVER', 'DEPARTMENT_ADMINISTRATOR', 'COMPANY_ADMINISTRATOR'],
      },
      seamlessParameter: {
        amcMemberNumber: '9904700095',
        companyManagementCode1: '',
        companyManagementCode2: '',
        companyManagementCode3: '',
        companyManagementCode4: '',
        departureDate1: '2024-08-28',
        departureDate2: '2024-09-11',
        sendDataFlag: '0',
        sendDataUrl: '',
        sendDataType: '1',
      },
      allBizContext: {
        companyId: 'IBX1234,20240101235959',
        loginUserID: '0000000001,20240101235959',
        companyName: 'ANAシステムズ株式会社',
        creditId: 11,
        isIssuable: 1,
        commercialFareFamilyList: '',
        issueType: 0,
        familyName: 'SORANO',
        givenName: 'TARO',
        emailAddress: 'sorano@mail.co.jp',
        dateOfBirth: '29-May-1985',
        gender: 'M',
        passengerMembershipNumber: 1234567890,
        addressType: IFlyAddressType.BUSINESS,
        phoneISDCode: '+81',
        phoneNumber: 9012345678,
        customerId: 123456,
        departmentId: 123456,
        departmentName: '営業部',
        userSeq: '1',
        agentSeq: '1',
        bizGeneralItem1: '2401010112345',
        bizGeneralItem2: '1234567890',
        bizGeneralItem3: '4/1 XXの打合せのため※羽田T2',
      },
    };
    this._common.anaBizContextStoreService.updateAnaBizContext(data);
    console.log('After:' + this._common.anaBizContextStoreService.anaBizContextData.authInfo?.companyInfoC?.pauseFlag);
  }

  gotoGoshokainet() {
    this._router.navigate(['goshokai-net-login']);
  }
}

const testRegions: Region[] | undefined = [
  {
    name: '日本',
    english_name: '',
    code: '01',
    display_type: '1',
    area: '4',
    order: 1,
    index_list: '',
    index_list_type: null,
  },
  {
    name: 'アメリカ',
    english_name: '',
    code: '02',
    display_type: '1',
    area: '1',
    order: 2,
    index_list: 'ア, カ, サ, タ, ナ, ハ, マ, ヤ, ラ, ワ',
    index_list_type: 0,
  },
];
const testAirports: Airport[] | undefined = [
  {
    name: '札幌(新千歳)',
    english_name: 'Sapporo(New Chitose)',
    airport_code: 'CTS',
    search_for_airport_code: 'CTS',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 6,
    order: 10,
    index: '',
    display_type: '1',
  },
  {
    name: '利尻',
    english_name: 'Rishiri',
    airport_code: 'RIS',
    search_for_airport_code: 'RIS',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 20,
    index: '',
    display_type: '1',
  },
  {
    name: '稚内',
    english_name: 'Wakkanai',
    airport_code: 'WKJ',
    search_for_airport_code: 'WKJ',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 30,
    index: '',
    display_type: '1',
  },
  {
    name: 'オホーツク紋別',
    english_name: 'Okhotsk Monbetsu',
    airport_code: 'MBE',
    search_for_airport_code: 'MBE',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 40,
    index: '',
    display_type: '1',
  },
  {
    name: '女満別',
    english_name: 'Memanbetsu',
    airport_code: 'MMB',
    search_for_airport_code: 'MMB',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 50,
    index: '',
    display_type: '1',
  },
  {
    name: '旭川',
    english_name: 'Asahikawa',
    airport_code: 'AKJ',
    search_for_airport_code: 'AKJ',
    region_code: '01',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 60,
    index: '',
    display_type: '1',
  },
  {
    name: 'ニューヨーク(全て)',
    english_name: 'New York(All)',
    airport_code: 'NYC',
    search_for_airport_code: 'NYC',
    region_code: '02',
    low_frequency_flag: false,
    frequency_used: 6,
    order: 50853,
    index: 'ナ',
    display_type: '1',
  },
  {
    name: 'ニューヨーク(EWR)',
    english_name: 'New York(EWR)',
    airport_code: 'EWR',
    search_for_airport_code: 'EWR',
    region_code: '02',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 50854,
    index: 'ナ',
    display_type: '1',
  },
  {
    name: 'ニューヨーク(JFK)',
    english_name: 'New York(JFK)',
    airport_code: 'JFK',
    search_for_airport_code: 'JFK',
    region_code: '02',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 50855,
    index: 'ナ',
    display_type: '1',
  },
  {
    name: 'ニューヨーク(LGA)',
    english_name: 'New York(LGA)',
    airport_code: 'LGA',
    search_for_airport_code: 'LGA',
    region_code: '02',
    low_frequency_flag: false,
    frequency_used: 0,
    order: 50856,
    index: 'ナ',
    display_type: '1',
  },
];
